export const formatDate = (date: string) => {
    const dateObj = new Date(date);
    const monthNames = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ];
    const month = monthNames[dateObj.getMonth()];
    const day = dateObj.getDate();

    return `${month} ${day}`;
};

export const getDebitCardTypeLabel = (
    type: string | null | undefined,
    fallback = 'Debit Card'
) => {
    if (type === 'givecard') {
        return 'Physical GiveCard';
    }

    if (type === 'virtual-givecard') {
        return 'Virtual GiveCard';
    }

    if (type === 'pex') {
        return 'PEX';
    }

    return fallback;
};
